import { makeUseFetchOneByParent } from '@elentari/core/hooks/makeUseFetchOne'
import { TabelaDetail } from '../../types/tabelaTypes'
import { tabelaSubRepository } from './tabelaSubRepository'

export const useTabela = makeUseFetchOneByParent<TabelaDetail, string, string>({
  fetch: tabelaSubRepository.fetchOne
})
